module.exports = __webpack_public_path__ + "img/product-card-hero-xl.a95433b.webp";